import createStreamingWorkerFunction from "../../../createStreamingWorkerFunction.js";
import createWorkerInNode from "../../../environment/createWorkerInNode.js";
export default function createStreamingWorkerFunctionInNode(fnOrAlias) {
    return createStreamingWorkerFunction(createWorkerInNode, fnOrAlias);
}
